import { defineComponent as _defineComponent } from 'vue'
import { PropType, Ref, ref } from 'vue';
import { NotificationBarPanelItem } from '@/models/Notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationBarItem',
  props: {
  item: {
    type: Object as PropType<NotificationBarPanelItem>,
    default: () => null
  },
  active: {
    type: Boolean,
  },
},
  emits: ['click'],
  setup(__props, { emit }) {




const btn = ref() as Ref<HTMLElement>;

const click = () => {
  const {
    left,
    right,
  } = btn.value.getBoundingClientRect();
  emit('click', (left + right) * 0.5);
};

return { __sfc: true,emit, btn, click }
}

})